module.exports = __webpack_public_path__ + "static/img/codeiocn1.73a65fd6.svg";